import { fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import { setError, setSuccess, startLoading } from "../store/appSlice";
// import * as CashProvidersFakeApi from "../fakeApi/CashManagementProviders";
import * as CashProvidersApi from "../api/CashManagementProviders";
import { callApi } from "./helpers/api";
import {
  cashManagementProviderOperationPaths,
  fetchCashManagementConfigurableProviders,
  fetchCashManagementProviders,
  fetchCashManagementSupportedCurrencies,
  setCashManagementConfigurableProviders,
  setList,
  setSupportedCurrencies,
} from "../store/cashManagementProviderSlice";

function* fetchProvidersSaga({
  payload,
}: {
  payload: {
    id: string;
  };
  type: string;
}) {
  const operationPath = ["cash", "provider", "list"];

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(CashProvidersApi.getCashManagementProviders);
    yield put(setList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchCashSupportedCurrenciesSaga(): Generator<any> {
  const operationPath = ["cash", "provider", "currency", "list"];

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(CashProvidersApi.getSupportedCurrencies);
    yield put(setSupportedCurrencies({ data }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchCashManagementConfigurableProvidersSaga({
  type,
}: {
  type: string;
}): Generator<any> {
  const {
    configurableProviders: operationPath,
  } = cashManagementProviderOperationPaths();

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(
      CashProvidersApi.getCashManagementConfigurableProviders
    );
    yield put(setCashManagementConfigurableProviders({ data }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchCashProviders() {
  yield takeEvery(fetchCashManagementProviders.type, fetchProvidersSaga);
}

function* watchFetchCashSupportedCurrencies() {
  yield takeEvery(
    fetchCashManagementSupportedCurrencies.type,
    fetchCashSupportedCurrenciesSaga
  );
}

function* watchFetchCashManagementConfigurableProviders() {
  yield takeLatest(
    fetchCashManagementConfigurableProviders.type,
    fetchCashManagementConfigurableProvidersSaga
  );
}

export function* CashProvidersSaga() {
  yield fork(watchFetchCashProviders);
  yield fork(watchFetchCashSupportedCurrencies);
  yield fork(watchFetchCashManagementConfigurableProviders);
}
